module.exports = __webpack_public_path__ + "img/logo.e541829e.jpg";